import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var FacebookDark = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    svgColor: "#fff",
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M44 22.134C44 9.91 34.15 0 22 0S0 9.91 0 22.134C0 33.182 8.045 42.34 18.563 44V28.533h-5.586v-6.399h5.585v-4.876c0-5.547 3.285-8.612 8.31-8.612 2.407 0 4.925.433 4.925.433v5.447h-2.774c-2.733 0-3.585 1.706-3.585 3.458v4.15h6.101l-.975 6.399h-5.127V44C35.956 42.34 44 33.182 44 22.134Z",
    svgColor: "#302C41"
  }));
});
FacebookDark.displayName = 'FacebookDark';
FacebookDark.defaultProps = {
  'aria-label': 'FacebookDark'
};
export default FacebookDark;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/FacebookDark.js
// module id = 3571
// module chunks = 11